import React, { useEffect, useState } from "react";
import { Col, Row, Avatar, Badge, Rate, Tooltip } from "antd";
import { StarFilled, ArrowLeftOutlined, StarOutlined } from "@ant-design/icons";
import "./styles.css";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import history from "../../../../routes/history";
import candidate_img from "../../../../assets/img/becomeACandidate.png";
import { WS } from "../../../../webSocket/defaultSocket";
import { getImageByStateCode } from "../../../CompanyProfile/components/cloudinary";
import moment from "moment";
import { DefaultRating } from "../../../../assets/helpers";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import { formatPhoneNumber } from "../../../../shared/helpers";
import { useDispatch, useSelector } from "react-redux";

const ChatHeader = ({
  chatDetails,
  setshowHistory,
  createdTime,
  jobDetails,
}) => {
  const [profilePic, setProfilePic] = useState();
  const [title, setTitle] = useState();
  const [chatType, setChatType] = useState();
  const [rating, setRating] = useState(DefaultRating);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [imageError, setImageError] = useState(false);
  const [empImageError, setEmpImageError] = useState(false);

  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));
  const notification = useSelector(
    (state) => state.fetchNotificationReducer.notification
  );

  const privateids = notification[0]?.senderprofile[0]?.EmployeeAssociation
  useEffect(async () => {
    setRating(chatDetails && chatDetails[0]?.RecipientUser?.Profiles?.Rating);
  }, [chatDetails]);

  useEffect(() => {
    if (chatDetails?.length) {
      getTitle();
    }
  }, [chatDetails]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function getTitle() {
    if (chatDetails?.length > 0) {
      if (chatDetails[0]?.SourceTypeId == 1) {
        setTitle(chatDetails[0]?.SkillListingCard?.Title);
        setChatType("Placed Bid");
      } else if (chatDetails[0]?.SourceTypeId == 2) {
        setTitle(chatDetails[0]?.GigCard?.Title);
        setChatType("Received bids");
      }
    }
  }

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const getProfileImage = () => {
    try {
      const isRecipient = chatDetails[0]?.SourceTypeId == 1;
      const user = isRecipient ? chatDetails[0]?.RecipientUser : chatDetails[0]?.SenderUser;
      const pictureUrl = user?.Profiles?.PictureUrl;

      if (!pictureUrl) {
        console.log("No picture URL available");
        return;
      }

      return pictureUrl?.charAt(0) === "/"
        ? `${process.env.REACT_APP_S3_URL}${pictureUrl}`
        : `${process.env.REACT_APP_S3_URL}/${pictureUrl}`;
    } catch (error) {
      console.log("Image issue:", error);
    }
  };

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        className="chatHeaderCont"
        aria-details={!userProfile1?.verification?.email && "extra-top"}
      >
        <Row
          className="chatHeaderFlex"
          onClick={() => {
            chatDetails && chatDetails[0]?.SourceTypeId == 1
              ? history.push({
                  pathname: `/profiledetail/${chatDetails[0].SkillListingCard?.SkillListingId}`,
                  state: {
                    id: chatDetails[0].SkillListingCard?.SkillListingId,
                    // GigId: props.job_id,
                    // JobTitle: props.job_title,
                    fromMatches: false,
                    fromSpecificRedirect: true
                    // Rating: props.Rating,
                    // Review: props.Review
                  },
                })
              : history.push({
                  pathname: "/candidateskilllisting",
                  state: {
                    // id: resume?.Profiles._id,
                    id: chatDetails[0].SenderUser?.AccountId,
                    fname: chatDetails[0].SenderUser?.Profiles?.FirstName,
                    lname: chatDetails[0].SenderUser?.Profiles?.LastName,
                  },
                });
          }}
        >
          <Row style={{ alignItems: "center", width: "80%" }}>
            <Col>
              <ArrowLeftOutlined
                style={{ fontSize: "14px" }}
                onClick={() => {
                  history.goBack();
                  setshowHistory(false);
                }}
              />
            </Col>

            <Col onClick={(e) => {e.stopPropagation(); e.preventDefault()}} style={{ marginLeft: "3%", cursor: "default" }}>
              {userProfile1?.EmployeeAssociation?.includes(chatDetails[0]?.SourceTypeId == 1 ? chatDetails[0]?.RecipientProfileId : chatDetails[0]?.SenderUser?.AccountId) && 
                <div className="chat-card-pvt-image2 chat-card-image-pvt2">
                    {(chatDetails &&
                    chatDetails.length > 0 &&
                    chatDetails[0].SourceTypeId !== 1
                      ? (chatDetails[0]?.RecipientUser?.Profiles?.PictureUrl && chatDetails[0]?.RecipientUser?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png")
                      : chatDetails[0]?.SenderUser?.Profiles?.PictureUrl && chatDetails[0]?.SenderUser?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png") &&
                    !empImageError ? (
                      <img
                        onError={() => setEmpImageError(true)}
                        style={{
                          width: "100%",
                        }}
                        src={getProfileImage()}
                        alt="title"
                      />
                    ) : (
                      <div className="emp-image-container">
                        <div className="emp-image-text">
                          {chatDetails &&
                          chatDetails?.length > 0 &&
                          chatDetails[0]?.SourceTypeId != 1
                            ? chatDetails[0]?.RecipientUser?.Profiles?.FirstName
                              ? chatDetails[0]?.RecipientUser?.Profiles?.FirstName?.split(
                                  ""
                                )[0].toUpperCase()
                              : chatDetails[0]?.RecipientUser?.UserName?.split(
                                  ""
                                )[0].toUpperCase()
                            : chatDetails[0]?.SenderUser?.Profiles?.FirstName
                            ? chatDetails[0]?.SenderUser?.Profiles?.FirstName?.split(
                                ""
                              )[0].toUpperCase()
                            : chatDetails[0]?.SenderUser?.UserName?.split(
                                ""
                              )[0].toUpperCase()}
                        </div>
                      </div>
                    )}
                  </div>
              }
              <div className="chat-card-image chat-card-pvt-image">
                {(chatDetails &&
                chatDetails.length > 0 &&
                chatDetails[0].SourceTypeId === 1
                  ? (chatDetails[0]?.RecipientUser?.Profiles?.PictureUrl && chatDetails[0]?.RecipientUser?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png")
                  : chatDetails[0]?.SenderUser?.Profiles?.PictureUrl && chatDetails[0]?.SenderUser?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png") &&
                !imageError ? (
                  <img
                    onError={() => setImageError(true)}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    src={getProfileImage()}
                    alt="title"

              />
                ) : (
                  <div className="image-container">
                    <div className="image-text">
                      {chatDetails &&
                      chatDetails?.length > 0 &&
                      chatDetails[0]?.SourceTypeId == 1
                        ? chatDetails[0]?.RecipientUser?.Profiles?.FirstName
                          ? chatDetails[0]?.RecipientUser?.Profiles?.FirstName?.split(
                              ""
                            )[0].toUpperCase()
                          : chatDetails[0]?.RecipientUser?.UserName?.split(
                              ""
                            )[0].toUpperCase()
                        : chatDetails[0]?.SenderUser?.Profiles?.FirstName
                        ? chatDetails[0]?.SenderUser?.Profiles?.FirstName?.split(
                            ""
                          )[0].toUpperCase()
                        : chatDetails[0]?.SenderUser?.UserName?.split(
                            ""
                          )[0].toUpperCase()}
                    </div>
                  </div>
                )}
              </div>
            </Col>

            <Col style={{ marginLeft: "3%", width: "70%" }}>
            <div className="nameTitle" style={{ cursor: "pointer" }}>
                  <div>
                    {chatDetails && chatDetails[0]?.SourceTypeId == 1
                      ? chatDetails[0]?.RecipientUser?.Profiles?.FirstName
                        ? capitalizeFirstLetter(
                            chatDetails[0]?.RecipientUser?.Profiles?.FirstName
                          ) +
                          " " +
                          capitalizeFirstLetter(
                            chatDetails[0]?.RecipientUser?.Profiles?.LastName
                          )
                        : "User Name"
                      : chatDetails[0]?.SenderUser?.Profiles?.FirstName
                      ? capitalizeFirstLetter(
                          chatDetails[0]?.SenderUser?.Profiles?.FirstName
                        ) +
                        " " +
                        capitalizeFirstLetter(
                          chatDetails[0]?.SenderUser?.Profiles?.LastName
                        )
                      : "User Name"}
                  </div>
                  <div style={{ marginLeft: "6%" }}>
                    <StarFilled
                      style={{ fontSize: "12px", color: "#ffba08" }}
                    />
                    <span style={{ color: "#ffba08", fontSize: "12px" }}>
                      {chatDetails?.length > 0 &&
                      chatDetails[0]?.SourceTypeId == 1
                        ? chatDetails[0]?.RecipientUser?.Profiles?.Rating
                          ? " " +
                            chatDetails[0]?.RecipientUser?.Profiles?.Rating
                          : " " + DefaultRating
                        : chatDetails[0]?.SenderUser?.Profiles?.Rating
                        ? chatDetails[0]?.SenderUser?.Profiles?.Rating
                          : " " + DefaultRating}
                    </span>{" "}
                    <span style={{ color: "#7e7e7e", fontSize: "12px" }}>
                      {chatDetails?.length > 0
                        ? chatDetails[0]?.SourceTypeId == 1
                          ? chatDetails[0]?.RecipientUser?.Profiles?.Review
                            ? "(" +
                              chatDetails[0]?.RecipientUser?.Profiles?.Review +
                              ")"
                            : ""
                          : chatDetails[0]?.SenderUser?.Profiles?.Review
                          ? "(" +
                            chatDetails[0]?.SenderUser?.Profiles?.Review +
                            ")"
                          : ""
                        : chatDetails?.length > 0
                        ? chatDetails[0]?.SourceTypeId == 1
                          ? chatDetails[0]?.RecipientUser?.Profiles?.Review
                            ? "(" +
                              chatDetails[0]?.RecipientUser?.Profiles?.Review +
                              ")"
                            : ""
                          : chatDetails[0]?.SenderUser?.Profiles?.Review
                          ? "(" +
                            chatDetails[0]?.SenderUser?.Profiles?.Review +
                            ")"
                          : ""
                        : null}
                    </span>
                  </div>
                </div>
              <div>
                <div className="chat-header-job-Title">
                  <Tooltip
                    title={title ? (title.length > 100 ? `${title.slice(0, 100)}...` : title) : ""}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.preventDefault()}
                    trigger={['click', 'hover']}
                  >
                    <span
                      onClick={(e) => e.stopPropagation()}
                      style={{ cursor: "pointer" }}
                    >
                      {title && title.length > 100
                        ? `${title.slice(0, 100)}...`
                        : title}
                    </span>
                  </Tooltip>
                </div>

                {/* <div className="nameTitle" style={{ cursor: "pointer" }}>
                  <div>
                    {chatDetails && chatDetails[0]?.SourceTypeId == 1
                      ? chatDetails[0]?.RecipientUser?.Profiles?.FirstName
                        ? capitalizeFirstLetter(
                            chatDetails[0]?.RecipientUser?.Profiles?.FirstName
                          ) +
                          " " +
                          capitalizeFirstLetter(
                            chatDetails[0]?.RecipientUser?.Profiles?.LastName
                          )
                        : "User Name"
                      : chatDetails[0]?.SenderUser?.Profiles?.FirstName
                      ? capitalizeFirstLetter(
                          chatDetails[0]?.SenderUser?.Profiles?.FirstName
                        ) +
                        " " +
                        capitalizeFirstLetter(
                          chatDetails[0]?.SenderUser?.Profiles?.LastName
                        )
                      : "User Name"}
                  </div>
                  <div style={{ marginLeft: "6%" }}>
                    <StarFilled
                      style={{ fontSize: "12px", color: "#ffba08" }}
                    />
                    <span style={{ color: "#ffba08", fontSize: "12px" }}>
                      {chatDetails?.length > 0 &&
                      chatDetails[0]?.SourceTypeId == 1
                        ? chatDetails[0]?.RecipientUser?.Profiles?.Rating
                          ? " " +
                            chatDetails[0]?.RecipientUser?.Profiles?.Rating
                          : " " + DefaultRating
                        : chatDetails[0]?.SenderUser?.Profiles?.Rating
                        ? chatDetails[0]?.SenderUser?.Profiles?.Rating
                          : " " + DefaultRating}
                    </span>{" "}
                    <span style={{ color: "#7e7e7e", fontSize: "12px" }}>
                      {chatDetails?.length > 0
                        ? chatDetails[0]?.SourceTypeId == 1
                          ? chatDetails[0]?.RecipientUser?.Profiles?.Review
                            ? "(" +
                              chatDetails[0]?.RecipientUser?.Profiles?.Review +
                              ")"
                            : ""
                          : chatDetails[0]?.SenderUser?.Profiles?.Review
                          ? "(" +
                            chatDetails[0]?.SenderUser?.Profiles?.Review +
                            ")"
                          : ""
                        : chatDetails?.length > 0
                        ? chatDetails[0]?.SourceTypeId == 1
                          ? chatDetails[0]?.RecipientUser?.Profiles?.Review
                            ? "(" +
                              chatDetails[0]?.RecipientUser?.Profiles?.Review +
                              ")"
                            : ""
                          : chatDetails[0]?.SenderUser?.Profiles?.Review
                          ? "(" +
                            chatDetails[0]?.SenderUser?.Profiles?.Review +
                            ")"
                          : ""
                        : null}
                    </span>
                  </div>
                </div> */}
                <div className="chat-header-MsgType">
  {chatType} <span style={{ margin: "0 5px", color:'#C5C5C5' }}>•</span> {/* Dot added here */}
  <div className="conversation-card-extraContent-time">last active {moment(createdTime)?.fromNow()}
  </div>
</div>
              </div>
            </Col>
          </Row>
          {/* <div className="conversation-card-extraContent-time">
            {moment(createdTime)?.fromNow()}
          </div> */}
        </Row>
        <div className="chat-contact-div">
          <div className="contact-inner-container-div">
          <Row>
            <div className="contact-email-div">
              <div className='contact-email-icon'>
                <AiOutlineMail />
              </div>
              <div style={{color: "#4054b2", whiteSpace: "nowrap"}}>
              {
               userProfile1?.AccountId === chatDetails[0]?.RecipientUser?.AccountId ?
               chatDetails[0]?.SenderUser?.EmailAddress : chatDetails[0]?.RecipientUser?.EmailAddress
              }
              </div>   
              </div>
            </Row>
            <Row>           
              { chatDetails[0]?.SkillListingCard?.MobilePhone &&
                <div className="contact-email-div">
                  <div className='contact-phone-icon'>
                  <BsTelephone/>
                  </div>
                 <div style={{whiteSpace: "nowrap"}} >
                   {formatPhoneNumber(chatDetails[0]?.SkillListingCard?.MobilePhone)}
                 </div>
                 </div>
               }            
          </Row>
          </div>          
        </div>
        <div className="chat-header-bottom">
          <div
            className="job-title-text"
            onClick={() => {
              if (jobDetails?.JobOrderId) {
                history.push({
                  pathname: `/jobdetail/${jobDetails?.JobOrderId}`,
                  state: {
                    id: jobDetails?.JobOrderId,
                    conversationId: chatDetails[0]?.ConversationId,
                    fromChat: true,
                  },
                });
              }
            }}
          >
            {jobDetails?.Title ?? "Gig Title"}
          </div>
        </div>
      </div>
    </>
  );
};
export default ChatHeader;
